<template>
  <div class="event">
    <Home :btnLoading="btnHomeLoading" :loading="loading" :tickets="tickets" v-if="!createTicket && _.isEmpty(activeTicket)"  @activeTicket="activeTicket = $event" @CreateTicket="createTicket = $event"></Home>
    <Create v-if="createTicket"  @CreateTicket="createTicket = $event"></Create>
    <Detail @activeTicket="activeTicket = $event" :activeTicket="activeTicket" v-if="!_.isEmpty(activeTicket)"></Detail>
  </div>
</template>

<script>
  import Home from '../../components/User/Messages/Home'
  import Create from '../../components/User/Messages/Create'
  import Detail from '../../components/User/Messages/Detail'
  export default{
    data(){
      return{
          activeTicket: this.$route.query.ticket ? parseInt(this.$route.query.ticket) : {},
          createTicket: false,
          updateForm:{
            message:'',
          },
          loading: false,
          tickets: [],
          btnHomeLoading: false,
      }
    },
    components:{
      Home,
      Create,
      Detail
    },
    created(){
        this.fetchData();
    },
    watch:{
      activeTicket(newVal,oldVal){
        if(_.isEmpty(newVal)){
          this.fetchData()
          this.$store.dispatch('wallet/ticketCount')
        }
      },
      createTicket(newVal,oldVal){
        this.fetchData();
      },
    },
    methods:{
        fetchData(val){
           this.loading = true;
            axios.get('/user/tickets', { params:{ ...val } })
            .then((response)=>{
              this.tickets 	= response.data.tickets;
              if(this.$route.query.ticket){
                this.setActive(this.activeTicket);
              } 
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
              this.btnHomeLoading = false;
            });
        },
        setActive(val){
              let activeticket = _.filter(this.tickets, function(o) { return o.ticket_id == val });
              this.activeTicket = activeticket[0];
        }
    }
  }
</script>